export * from './resetPassword.component'
